(function () {
    function lhm_getZimmerCardActiveSlide(track, slides) {
        const scrollLeft = track.scrollLeft;
        let activeSlide = 0;

        slides.forEach((slide, i) => {
            if (slide.offsetLeft <= scrollLeft + 1) {
                activeSlide = i;
            }
        });

        return activeSlide;
    }

    function lhm_updateZimmerCardNav(card) {
        const track = card.querySelector('.zimmerCardTrack');
        const prev = card.querySelector('.zimmerCardPrev');
        const next = card.querySelector('.zimmerCardNext');

        if (!track || !prev || !next) {
            return;
        }

        const slides = Array.from(track.children);
        const activeSlide = lhm_getZimmerCardActiveSlide(track, slides);

        prev.disabled = activeSlide === 0;
        next.disabled = activeSlide === slides.length - 1;

        card.classList.toggle('zimmerCard-hasSlider', slides.length > 1);
    }

    function lhm_stepZimmerCard(card, direction) {
        const track = card.querySelector('.zimmerCardTrack');

        if (!track) {
            return;
        }

        const slides = Array.from(track.children);
        const activeSlide = lhm_getZimmerCardActiveSlide(track, slides);
        const targetSlide = slides[activeSlide + direction];

        if (targetSlide) {
            track.scrollTo({ left: targetSlide.offsetLeft, behavior: 'smooth' });
        }
    }

    function lhm_initZimmerCardDrag(track) {
        let isPointerDown = false;
        let dragged = false;
        let startX = 0;
        let scrollStart = 0;
        let pendingLeft = null;

        function applyScroll() {
            if (pendingLeft !== null) {
                track.scrollLeft = pendingLeft;
                pendingLeft = null;
            }
        }

        function onMove(e) {
            if (!isPointerDown) {
                return;
            }

            const delta = e.clientX - startX;

            if (!dragged && Math.abs(delta) > 10) {
                dragged = true;
                track.classList.add('zimmerCardTrack-dragging');
            }

            if (dragged) {
                const isFirstPending = pendingLeft === null;
                pendingLeft = scrollStart - delta;

                if (isFirstPending) {
                    requestAnimationFrame(applyScroll);
                }
            }
        }

        function endDrag(e) {
            isPointerDown = false;
            track.classList.remove('zimmerCardTrack-dragging');
            track.releasePointerCapture(e.pointerId);
        }

        track.addEventListener('pointerdown', (e) => {
            if (e.pointerType === 'touch') {
                return;
            }

            e.preventDefault();
            track.setPointerCapture(e.pointerId);
            isPointerDown = true;
            dragged = false;
            startX = e.clientX;
            scrollStart = track.scrollLeft;
        });

        track.addEventListener('pointermove', onMove);
        track.addEventListener('pointerup', endDrag);
        track.addEventListener('pointercancel', endDrag);

        track.addEventListener('click', (e) => {
            if (dragged) {
                e.preventDefault();
                e.stopPropagation();
                dragged = false;
            }
        }, true);
    }

    function lhm_initZimmerCard(card) {
        const track = card.querySelector('.zimmerCardTrack');
        const prev = card.querySelector('.zimmerCardPrev');
        const next = card.querySelector('.zimmerCardNext');

        if (!track) {
            return;
        }

        if (prev) {
            prev.addEventListener('click', () => lhm_stepZimmerCard(card, -1));
        }

        if (next) {
            next.addEventListener('click', () => lhm_stepZimmerCard(card, 1));
        }

        lhm_updateZimmerCardNav(card);
        lhm_initZimmerCardDrag(track);

        track.addEventListener('keydown', (e) => {
            if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') {
                return;
            }

            e.preventDefault();
            lhm_stepZimmerCard(card, e.key === 'ArrowRight' ? 1 : -1);
        });

        let scrollTicking = false;
        track.addEventListener('scroll', () => {
            if (!scrollTicking) {
                scrollTicking = true;
                requestAnimationFrame(() => {
                    lhm_updateZimmerCardNav(card);
                    scrollTicking = false;
                });
            }
        }, { passive: true });
    }

    function lhm_initZimmerFilter(outer) {
        const toggle = outer.querySelector('.zimmerFilterToggle');
        const panel = outer.querySelector('.zimmerFilterPanel');
        const tabs = Array.from(outer.querySelectorAll('.zimmerFilterTab'));
        const section = outer.closest('.layoutZimmerubersicht');
        const cards = section ? Array.from(section.querySelectorAll('.zimmerCard')) : [];

        if (!toggle || !panel) {
            return;
        }

        toggle.addEventListener('click', () => {
            const isOpen = !panel.hidden;
            panel.hidden = isOpen;
            toggle.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
        });

        tabs.forEach((tab) => {
            tab.addEventListener('click', () => {
                tabs.forEach((t) => t.setAttribute('aria-selected', 'false'));
                tab.setAttribute('aria-selected', 'true');

                const value = tab.dataset.filterValue;

                cards.forEach((card) => {
                    const show = value === 'alle' || card.dataset.maxPersonen === value;
                    card.classList.toggle('zimmerCard-filteredOut', !show);
                    card.hidden = !show;
                });
            });
        });
    }

    function lhm_initZimmerubersicht() {
        document.querySelectorAll('.zimmerCard').forEach(lhm_initZimmerCard);
        document.querySelectorAll('.zimmerFilterOuter').forEach(lhm_initZimmerFilter);
    }

    window.addEventListener('load', lhm_initZimmerubersicht);
})();
